// Module
var code = `<label class="columns-label">Columns:</label>
<div class="container">
</div>`;
// Exports
export default code;